var React = require('react');
import {fmDate, fmDateTime} from '../common/formatter.jsx';

/*----------------------------------------------------------------------------
|
|   OSS Widget commonly used functions
|
|
|   written by Jochen Loewer and Adolf Krauss
|   July 2014
|
\--------------------------------------------------------------------------*/
function fmSddDate(sddDate, sddComment) {
    if (sddComment != "")
        return sddComment;
    else
        return fmDate(sddDate);
}


export function mapItemStatus(itemStatus, tenant) {
  if ( tenant == 'HPICS') {
    return itemStatus;
  } else {
      if (itemStatus == 'Processing' || itemStatus == 'Acked') {
          return 'Processing';
      } else
      if (itemStatus == 'Production' || itemStatus == 'ProductionDone' || itemStatus == 'FactShipped' || itemStatus == 'Registered') {
          return 'Production';
      } else
      if (itemStatus == 'ShipmentScheduled') {
          return 'Shipment Scheduled';
      } else
      if (itemStatus == 'Shipped') {
          return 'Shipped to Customer';
      } else
      if (itemStatus == 'ShipmentCanceled') {
          return 'Shipment Canceled';
      } else {
          return itemStatus;
      }
  }
}


function SplitByStatus(items, stati) {
    var splitItems = [];

    for (var i = 0; i < items.length; i++) {
        if (stati.indexOf(items[i].status) >= 0) {
            splitItems.push(items[i]);
        }
    }
    return splitItems;
}

function SplitByOdm(items, stati) {
    var splitItems = [];

    for (var i = 0; i < items.length; i++) {
        if(items[i].odm_reason != "" ) {
          if(items[i].higher_level == "0") {
            if (stati.indexOf(items[i].status) >= 0) {
              splitItems.push(items[i]);
            }
          }
        }
    }
    return splitItems;
}

export function RemoveBom3Bom5LowerLevel(items) {
    var HlItems = [];

    for (var i = 0; i < items.length; i++) {
        if(items[i].bundle_type != "MCCBundle-Child" && items[i].bundle_type != "MCCBundle-Child-War" ) {
            HlItems.push(items[i]);
        } else if ( ((items[i].sales_org != 'BR12' && items[i].bundle_type != "MCCBundle-Child-AC") || items[i].sales_org == 'BR12')) {
            HlItems.push(items[i]);          
        }
    }
    return HlItems;
}

function groupByHL(items, skip_hl_sched_logic) {
  // build up map so_item_no --> item_subitem
  var soitem2itemsubitem = {};
  var item2Higherlevel = {};
  var itemindex = {};
  for (var i = 0; i < items.length; i++) {
    soitem2itemsubitem[items[i].so_item_no] = items[i].item_subitem;
    item2Higherlevel[items[i].so_item_no] = items[i].higher_level;
    itemindex[items[i].so_item_no] = i;
    items[i].done = false;
    items[i].lower_level_items = [];
  }

// translate higherlevel so item no into so_item_no
  for (var i = 0; i < items.length; i++) {
    if (items[i].higher_level == items[i].so_item_no) {
      items[i].higher_level = 0;
    }
    if (items[i].higher_level != 0) {
      // iterational approach to allign different lower level items to the main higher leven item
      if (item2Higherlevel[items[i].so_item_no] != 0) {
        var temp1 = item2Higherlevel[items[i].so_item_no]
        if ( item2Higherlevel[temp1] != 0 && item2Higherlevel[temp1] != undefined ) {
          var temp2 = item2Higherlevel[temp1]

          var hlindex = itemindex[temp1];
          items[hlindex].lower_level_items.push(items[i]);
          items[i].done = true;
          
          if (item2Higherlevel[temp2] == 0) {
          //  items[i].higher_level = temp2;
          } else {
          //  items[i].higher_level = item2Higherlevel[temp2];
          }
        } else {
          items[i].higher_level = temp1;
        }
      }
    }
  }

  var grouped = {};
  var hlItemSchedLine  = {};
  var hlItemsArr = [];
  for (var i = 0; i < items.length; i++) {
    //items[i].lower_level_items = [];
    if (items[i].higher_level == 0) {
      grouped[items[i].item_sln] = items[i];
      items[i].done = true;
      hlItemSchedLine[items[i].so_item_no] = items[i].item_sln

      hlItemsArr.push({
        item_sln      : items[i].item_sln,
        hl_item       : items[i].so_item_no,
        fact_delv_no  : items[i].fact_delv_no,
      });

    }
  }

  var repeat = true;
  var mapViaFactDelvNo = false;
  var mapViaHlSchedLine = false;
  while (repeat) {
    repeat = false;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].done) {
        //console.log(grouped[hlItemSchedLine[items[i].higher_level]]);

        // new logic which uses the backend set hl_sched_line value
        if (!skip_hl_sched_logic) {
          for (var x = 0; x < hlItemsArr.length; x++) {
            if (hlItemsArr[x].item_sln == items[i].hl_sched_line) {
              grouped[hlItemsArr[x].item_sln].lower_level_items.push(items[i]);
              items[i].done = true;
              repeat = true;
              mapViaHlSchedLine = true;
            }
          }
        }

        if (!mapViaHlSchedLine) {
          // new logic to take fact_delv_no into consideration to map ll items to the correct hl items
          for (var x = 0; x < hlItemsArr.length; x++) {
            if (hlItemsArr[x].hl_item == items[i].higher_level && hlItemsArr[x].fact_delv_no == items[i].fact_delv_no && items[i].fact_delv_no != "") {
              grouped[hlItemsArr[x].item_sln].lower_level_items.push(items[i]);
              items[i].done = true;
              repeat = true;
              mapViaFactDelvNo = true;
            } else {
              mapViaFactDelvNo = false;
            }
          }
          // legacy code remains as fallback when fact_delv_no is not available yet
          if (mapViaFactDelvNo == false && items[i].done != true) {
            if (grouped[hlItemSchedLine[items[i].higher_level]]) {
              grouped[hlItemSchedLine[items[i].higher_level]].lower_level_items.push(items[i]);
              items[i].done = true;
              repeat = true;
            } else {
              grouped[items[i].item_sln] = items[i];
              items[i].done = true;
              repeat = true;
            }
          }
        }
      }
    }
  }

  var hlItems = [];
  for (var i in grouped) {
    if (grouped.hasOwnProperty(i)) hlItems.push(grouped[i]);
  }
  return hlItems;
}

function groupByBundle(items) {
    var grouped = {};
    for (var i = 0; i < items.length; i++) {
        items[i].bundledone = false;
        if (grouped[items[i].bundle_id]) {
            var hl = items[i].higher_level;
            if (hl != 0) {
                // not add childs
            } else {
                grouped[items[i].bundle_id].push(items[i]);
                items[i].bundledone = true;
            }
        } else {
            grouped[items[i].bundle_id] = [items[i]];
            items[i].bundledone = true;
        }
    }
    for (var i = 0; i < items.length; i++) {
        if (!items[i].bundledone) {
            grouped[items[i].bundle_id].push(items[i]);
            items[i].bundledone = true;
        }
    }
    return grouped;
}

function compareItem(a, b) {
    if (!isNaN(parseInt(a)) && !isNaN(parseInt(b))) {
        return (parseInt(a) - parseInt(b));
    }
    if (a < b) return -1;
    if (a > b) return +1;
    return 0;
}

export function constructRows(data, mapFn) {

    data.sort(function(a, b) {
        var item_subitemA = null;
        var item_subitemB = null;
        if (a.group) {
          if (a.children[0].main) {
            item_subitemA = a.children[0].main.item_subitem
          } else {
            item_subitemA = a.children[0].item_subitem;
          }
        } else
        if (a.main) {
          item_subitemA = a.main.item_subitem;
        } else {
          item_subitemA = a.item_subitem;
        }

        if (b.group) {
          if (b.children[0].main) {
            item_subitemB = b.children[0].main.item_subitem
          } else {
            item_subitemB = b.children[0].item_subitem;
          }
        } else
        if (b.main) {
          item_subitemB = b.main.item_subitem;
        } else {
          item_subitemB = b.item_subitem;
        }

        return compareItem(item_subitemA, item_subitemB)
    });

    var output = [];
    for (var i = 0; i < data.length; i++) {
        if (data[i].group) {
            // this a bundle structure
            // show bundle name instead of bundle id
            var config_id;
            // Conditions for showing the config_id based on BlMonSCCommitLogic
            if (data[i].children[0].main) {
                if (data[i].children[0].main.bundle_name.includes("Config") || 
                    data[i].children[0].main.config_id.includes("-") ||
                    data[i].children[0].main.bundle_name.includes(data[i].children[0].main.config_id) ||
                    data[i].children[0].main.bundle_name == data[i].children[0].main.config_id) {
                    config_id = '';
                } else {
                    config_id = ' (' + data[i].children[0].main.config_id + ')';
                }
                var bundle_name = data[i].children[0].main.bundle_name + config_id;
            } else {
                if (data[i].children[0].bundle_name.includes("Config") || 
                    data[i].children[0].config_id.includes("-") ||
                    data[i].children[0].bundle_name.includes(data[i].children[0].config_id) ||
                    data[i].children[0].bundle_name == data[i].children[0].config_id) {
                    config_id = '';
                } else {
                    config_id = ' (' + data[i].children[0].config_id + ')';
                }
                var bundle_name = data[i].children[0].bundle_name + config_id;
            }
            if (bundle_name.length == 0) {
                if (data[i].children[0].main) {
                    var bundle_name = data[i].children[0].main.bundle_id + config_id;
                } else {
                    var bundle_name = data[i].children[0].bundle_id + config_id;
                }
            }
            output.push({
                group: bundle_name,
                children: constructRows(data[i].children, mapFn)
            });

        } else
        if (data[i].main) {
            // this a higher level item structure
            output.push({
                main: mapFn(data[i].main),
                children: constructRows(data[i].children, mapFn)
            });
        } else {
            // this are flat rows
            output.push(mapFn(data[i]));
        }
    }
    return output;
}

function constructSubLevel(higherItemsU) {

    var output = [];
    var higherItems = higherItemsU.sort(function(a, b) {
        if (a.item_subitem && b.item_subitem) {
            return compareItem(a.item_subitem, b.item_subitem)
        }
        return 0;
    });
    for (var i = 0; i < higherItems.length; i++) {
         if (higherItems[i].lower_level_items && higherItems[i].lower_level_items.length > 0) {
            output.push({
                main: higherItems[i],
                children:  higherItems[i].lower_level_items
            });
        } else {
            output.push(higherItems[i]);
        }
    }
    return output;
}



function constructHigherLevel(higherItemsU) {
    var output = [];
    var higherItems = higherItemsU.sort(function(a, b) {
        if (a.item_subitem && b.item_subitem) {
            return compareItem(a.item_subitem, b.item_subitem)
        }
        return 0;
    });
    for (var i = 0; i < higherItems.length; i++) {
        if (higherItems[i].lower_level_items && higherItems[i].lower_level_items.length > 0) {
            output.push({
                main: higherItems[i],
                children: constructSubLevel(higherItems[i].lower_level_items)
            });
        } else {
            output.push(higherItems[i]);
        }
    }
    return output;
}


function constructNestedDataset(bundles) {
    var output = [];0
    for (var bundleName in bundles) {
        if (bundleName != undefined && bundleName != '') {
            output.push({
                group: bundleName,
                children: constructHigherLevel(bundles[bundleName])
            });
        } else {
            var tmp = constructHigherLevel(bundles[bundleName]);
            for (var i = 0; i < tmp.length; i++) {
               output.push( tmp[i] );
            }
        }
    }
    return output;
}

export function GetBundleStructure(items, itemBundleStructures) {

    itemBundleStructures.bundles = constructNestedDataset(groupByBundle(groupByHL(items)));

}

export function constructRowsWrapper(data,zmsoFlag, mapFn) {
    if( zmsoFlag ) {
        var ndata = [];
        for(var i=0 ; i < data.length;i++) {
            let akey        = data[i].akey;
            let moreInfo    = data[i].moreInfo;

            var r = constructRows(data[i].children,mapFn);
            ndata.push ({
                akey     : akey,
                moreInfo : moreInfo,
                children : r
            });
        }
        return ndata;
    } else {
        return constructRows(data,mapFn);
    }
}

function composeValueFromShipTo(moreInfo) {

    let composedValue = "";
    if (moreInfo.name1) {
        composedValue = moreInfo.name1;
    } else
    if (moreInfo.name2) {
        composedValue = moreInfo.name2;
    } else
    if (moreInfo.name3) {
        composedValue = moreInfo.name3;
    }

    if (moreInfo.email_address) {
        composedValue = ( composedValue ? composedValue + " | " + moreInfo.email_address : moreInfo.email_address);
    }
    return composedValue;
}

function groupByZMSO(items) {

    var fitems   = [];
    var ggroup   = {};
    var kgroup   = {};
    var moreInfo = {};


    for (var k = 0; k < items.length; k++) {
        if(items[k].group) {

            for(var a = 0; a < items[k].children.length ; a++) {

                let child_so_no         = "";
                let email_address       = "";
                let ship_to_group_id    = "";
                let akey                = "";
                let type                = "NOGROUP";
                let zmso_details        = {};


                if(items[k].children[a] && items[k].children[a].main ) {
                    zmso_details        = items[k].children[a].main.zmso_details;
                    child_so_no         = zmso_details.child_so_no;
                    email_address       = zmso_details.email_address;
                    ship_to_group_id    = zmso_details.ship_to_group_id;

                } else
                if(items[k].children[a]) {
                    zmso_details        = items[k].children[a].zmso_details;
                    child_so_no         = zmso_details.child_so_no;
                    email_address       = zmso_details.email_address;
                    ship_to_group_id    = zmso_details.ship_to_group_id;

                }
                if( child_so_no && child_so_no != "" ) {
                    akey = child_so_no ;
                    type = "child_so_no"
                } else if( ship_to_group_id && ship_to_group_id != "" ) {
                    akey = ship_to_group_id ;
                    type = "ship_to_group_id"
                } else if( email_address && email_address != "" ) {
                    akey = email_address ;
                    type = "email_address"
                }

                //moreInfo[akey]    ? "" : moreInfo[akey] = {} ;
                if( !moreInfo[akey] ) {
                    moreInfo[akey] = {} ;
                    moreInfo[akey]["zmso_details"]       = zmso_details;
                    moreInfo[akey]["email_address"]      = email_address ;
                    moreInfo[akey]["type"]               = type ;
                    moreInfo[akey]["composed_value"]     = ( type == "child_so_no" ? email_address : composeValueFromShipTo(zmso_details) );
                    moreInfo[akey]["composed_value"]     = ( type == "NOGROUP" ? '' : moreInfo[akey]["composed_value"] );
                }

                ggroup[akey]                        ? "" : ggroup[akey] = {} ;
                ggroup[akey][items[k].group]        ? "" : ggroup[akey][items[k].group] = [];

                kgroup[akey]                        ? "" : kgroup[akey] = [];

                ggroup[akey][items[k].group].push(items[k].children[a]);
            }
        } else {
            let email_address      = "";
            let child_so_no        = "";
            let ship_to_group_id   = "";
            let akey               = "";
            let type               = "NOGROUP";
            let zmso_details       = {};


            if(items[k].main) {
                zmso_details        = items[k].main.zmso_details;
                child_so_no         = zmso_details.child_so_no;
                email_address       = zmso_details.email_address;
                ship_to_group_id    = zmso_details.ship_to_group_id;

            } else {
                zmso_details        = items[k].zmso_details;
                child_so_no         = zmso_details.child_so_no;
                email_address       = zmso_details.email_address;
                ship_to_group_id    = zmso_details.ship_to_group_id;

            }

            if( child_so_no && child_so_no != "" ) {
                akey = child_so_no ;
                type = "child_so_no"
            } else if( ship_to_group_id && ship_to_group_id != "" ) {
                akey = ship_to_group_id ;
                type = "ship_to_group_id"
            } else if( email_address && email_address != "" ) {
                akey = email_address ;
                type = "email_address"
            }

            if( !moreInfo[akey] ) {
                moreInfo[akey] = {} ;
                moreInfo[akey]["zmso_details"]       = zmso_details;
                moreInfo[akey]["email_address"]      = email_address ;
                moreInfo[akey]["type"]               = type ;
                moreInfo[akey]["composed_value"]     = ( type == "child_so_no" ? email_address : composeValueFromShipTo(zmso_details) );
                moreInfo[akey]["composed_value"]     = ( type == "NOGROUP" ? '' : moreInfo[akey]["composed_value"] );
            }
            kgroup[akey]         ? "" : kgroup[akey] = [];
            kgroup[akey].push(items[k]);

        }

    }
    // console.log("ggroup is ",JSON.stringify(ggroup,null,4));
    // console.log("kgroup is ",JSON.stringify(kgroup,null,4));

    for ( let akey of Object.keys(ggroup)) {
        for ( let group of Object.keys(ggroup[akey])) {
            var children=[];
            var sitems = ggroup[akey][group];
            for (var i = 0; i < sitems.length; i++) {
                // console.log("sitems is ",sitems[i]);
                children.push(sitems[i]);
            }
            kgroup[akey].push( { group :group,
                                 children:children });
        }
    }

    for ( let akey of Object.keys(kgroup)) {
        fitems.push({
            akey     : akey ,
            moreInfo : moreInfo[akey] ? moreInfo[akey] : {} ,
            children :kgroup[akey]

        })
    }
    return fitems;
}

//-----------------------------------------------
//  PolyOrder
//  identify Poly orders
//-----------------------------------------------
export function PolyOrder(order) {
    for ( let el of Object.keys(order.api_asset_profiles)) {
        if (order.api_asset_profiles[el].api_asset_profile == 'POLY') {
            return true;
        }
    }
    return false;
}

//-----------------------------------------------
//  PolyServiceOrder
//  identify Poly orders containing  a service
//-----------------------------------------------
export function PolyServiceOrder(order) {
    for ( let el of Object.keys(order.api_asset_profiles)) {
        if (order.api_asset_profiles[el].api_asset_profile == 'POLY_SERVICE') {
            return true;
        }
    }
    return false;
}

//-----------------------------------------------
//  ZMSOOrder
//  identify ZMSO orders
//-----------------------------------------------
 export function ZMSOOrder(order) {
     if (order.order_type == 'ZMSO') {
         return true;
     }
      return false;
 }

//-----------------------------------------------
//  SOMOrder
//  identify SOM orders (Subscription Contract / Solution Quotation)
//-----------------------------------------------
export function SOMOrder(order) {
    if (order.order_type && order.order_type.startsWith('SOM-')) {
        return true;
    }
    return false;
}

export function hasItemEndCustAddr(order) {
  if (Array.isArray(order.items) && order.items.length > 0) {
    return order.items.some(item => item.end_cust_addr_no !== undefined && item.end_cust_addr_no !== null && item.end_cust_addr_no !== '');
  }
  return false;
}


export function PrepareActiveItemGroupsForZMSO(items, groups, counts, groupCounts) {

    var submitted               = SplitByStatus(items, ["Submitted", "Pending"]);
    var accepted                = SplitByStatus(items, ["Acked", "Processing"]);
    var production              = SplitByStatus(items, ["Production", "ProductionDone"]);
    var shipmentScheduled       = SplitByStatus(items, ["ShipmentScheduled"]);
    var consolidation           = SplitByStatus(items, ["FactShipped", "Registered"]);
    var shippedToCustomer       = SplitByStatus(items, ["Shipped"]);
    var delivered               = SplitByStatus(items, ["Delivered"]);
    var shipmentCanceled        = SplitByStatus(items, ["ShipmentCanceled"]);
    var canceled                = SplitByStatus(items, ["CANCELED"]);
    var odmItems                = SplitByOdm(items, ["Submitted", "Acked", "Processing", "Production", "ProductionDone"]);
    var openItems               = SplitByStatus(items, ["Submitted", "Acked", "Processing", "Pending", "ShipmentScheduled", "Production", "ProductionDone", "FactShipped", "Registered"]);
    var shippedItems            = SplitByStatus(items, ["Shipped", "Delivered"]);
    var allStati                = submitted.concat(accepted, production, shipmentScheduled, consolidation, shippedToCustomer, delivered, shipmentCanceled, canceled);

    counts.submitted            = submitted.length;
    counts.accepted             = accepted.length;
    counts.production           = production.length;
    counts.shipmentScheduled    = shipmentScheduled.length
    counts.consolidation        = consolidation.length;
    counts.shippedToCustomer    = shippedToCustomer.length;
    counts.delivered            = delivered.length;
    counts.shipmentCanceled     = shipmentCanceled.length;
    counts.canceled             = canceled.length;
    counts.open                 = openItems.length;
    counts.shipped              = shippedItems.length;
    counts.odm                  = odmItems.length;

    groups.submitted            = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(submitted))));
    groups.accepted             = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(accepted))));
    groups.production           = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(production))));
    groups.shipmentScheduled    = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(shipmentScheduled))));
    groups.consolidation        = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(consolidation))));
    groups.shippedToCustomer    = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(shippedToCustomer))));
    groups.delivered            = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(delivered))));
    groups.shipmentCanceled     = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(shipmentCanceled))));
    groups.canceled             = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(canceled))));
    groups.open                 = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(openItems))));
    groups.shipped              = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(shippedItems))));
    groups.odm                  = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(odmItems))));
    groups.allStati             = groupByZMSO(constructNestedDataset(groupByBundle(groupByHL(allStati))));

    groupCounts.submitted            = groups.submitted.length;
    groupCounts.accepted             = groups.accepted.length;
    groupCounts.production           = groups.production.length;
    groupCounts.shipmentScheduled    = groups.shipmentScheduled.length;
    groupCounts.consolidation        = groups.consolidation.length;
    groupCounts.shippedToCustomer    = groups.shippedToCustomer.length;
    groupCounts.delivered            = groups.delivered.length;
    groupCounts.shipmentCanceled     = groups.shipmentCanceled.length;
    groupCounts.canceled             = groups.canceled.length;
    groupCounts.open                 = groups.open.length;
    groupCounts.shipped              = groups.shipped.length;
    groupCounts.odm                  = groups.odm.length;
    groupCounts.allStati             = groups.allStati.length;
}

export function PrepareActiveItemGroupsForSOM(items, groups, counts, groupCounts) {

    var submitted               = SplitByStatus(items, ["Submitted"]);
    var pending                 = SplitByStatus(items, ["Pending"]);
    var active                  = SplitByStatus(items, ["Active"]);
    var planned                 = SplitByStatus(items, ["Planned"]);
    var canceled                = SplitByStatus(items, ["Canceled", "CANCELED"]);
    var expired                 = SplitByStatus(items, ["Expired"]);
    var openItems               = SplitByStatus(items, ["Submitted", "Pending", "Planned"]);
    var shippedItems            = SplitByStatus(items, ["Active"]);
    var inactive                = SplitByStatus(items, ["Inactive"]);
    //for the hw item in solution quotation.
    var accepted                = SplitByStatus(items, ["Acked", "Processing"]);
    var production              = SplitByStatus(items, ["Production", "ProductionDone"]);
    var shipmentScheduled       = SplitByStatus(items, ["ShipmentScheduled"]);
    var consolidation           = SplitByStatus(items, ["FactShipped", "Registered"]);
    var shippedToCustomer       = SplitByStatus(items, ["Shipped"]);
    var delivered               = SplitByStatus(items, ["Delivered"]);
    var shipmentCanceled        = SplitByStatus(items, ["ShipmentCanceled"]);
    var allStati                = submitted.concat(pending, active, planned, canceled, expired, inactive, accepted, production, shipmentScheduled, consolidation, shippedToCustomer, delivered, shipmentCanceled);

    counts.submitted            = submitted.length;
    counts.pending              = pending.length;
    counts.active               = active.length;
    counts.planned              = planned.length;
    counts.canceled             = canceled.length;
    counts.expired              = expired.length;
    counts.open                 = openItems.length;
    counts.shipped              = shippedItems.length;
    counts.inactive             = inactive.length;

    groups.submitted            = constructNestedDataset(groupByBundle(groupByHL(submitted)));
    groups.pending              = constructNestedDataset(groupByBundle(groupByHL(pending)));
    groups.active               = constructNestedDataset(groupByBundle(groupByHL(active)));
    groups.planned              = constructNestedDataset(groupByBundle(groupByHL(planned)));
    groups.canceled             = constructNestedDataset(groupByBundle(groupByHL(canceled)));
    groups.expired              = constructNestedDataset(groupByBundle(groupByHL(expired)));
    groups.open                 = constructNestedDataset(groupByBundle(groupByHL(openItems)));
    groups.shipped              = constructNestedDataset(groupByBundle(groupByHL(shippedItems)));
    groups.inactive             = constructNestedDataset(groupByBundle(groupByHL(inactive)));
    groups.allStati             = constructNestedDataset(groupByBundle(groupByHL(allStati)));

    groupCounts.submitted       = groups.submitted.length;
    groupCounts.pending         = groups.pending.length;
    groupCounts.active          = groups.active.length;
    groupCounts.planned         = groups.planned.length;
    groupCounts.canceled        = groups.canceled.length;
    groupCounts.expired         = groups.expired.length;
    groupCounts.open            = groups.open.length;
    groupCounts.shipped         = groups.shipped.length;
    groupCounts.inactive        = groups.inactive.length;
    groupCounts.allStati        = groups.allStati.length;
}

export function PrepareItemGroupsForSOM(items, groups, counts) {
    var openItems    = SplitByStatus(items, ["Submitted", "Pending", "Planned"]);
    var shippedItems = SplitByStatus(items, ["Active"]);
    var canceledItems = SplitByStatus(items, ["Canceled", "CANCELED", "Expired"]);
    var eOdmItems    = openItems.concat(shippedItems, canceledItems);

    counts.open      = openItems.length;
    counts.shipped   = shippedItems.length;
    counts.canceled  = canceledItems.length;
    counts.eOdmItems = eOdmItems.length;

    groups.open      = constructNestedDataset(groupByBundle(groupByHL(openItems)));
    groups.shipped   = constructNestedDataset(groupByBundle(groupByHL(shippedItems)));
    groups.canceled  = constructNestedDataset(groupByBundle(groupByHL(canceledItems)));
    groups.eOdmItems = constructNestedDataset(groupByBundle(groupByHL(eOdmItems)));
}

export function PrepareActiveItemGroups(items, groups, counts, groupCounts) {

    var submitted               = SplitByStatus(items, ["Submitted", "Pending"]);
    var accepted                = SplitByStatus(items, ["Acked", "Processing"]);
    var production              = SplitByStatus(items, ["Production", "ProductionDone"]);
    var shipmentScheduled       = SplitByStatus(items, ["ShipmentScheduled"]);
    var consolidation           = SplitByStatus(items, ["FactShipped", "Registered"]);       
    var shippedToCustomer       = SplitByStatus(items, ["Shipped"]);
    var delivered               = SplitByStatus(items, ["Delivered"]);
    var shipmentCanceled        = SplitByStatus(items, ["ShipmentCanceled"]);
    var canceled                = SplitByStatus(items, ["CANCELED"]);
    var odmItems                = SplitByOdm(items, ["Submitted", "Acked", "Processing", "Production", "ProductionDone"]);
    var allStati                = submitted.concat(accepted, production, shipmentScheduled, consolidation, shippedToCustomer, delivered, shipmentCanceled, canceled);

    counts.submitted            = submitted.length;
    counts.accepted             = accepted.length;
    counts.production           = production.length;
    counts.shipmentScheduled    = shipmentScheduled.length
    counts.consolidation        = consolidation.length;
    counts.shippedToCustomer    = shippedToCustomer.length;
    counts.delivered            = delivered.length;
    counts.shipmentCanceled     = shipmentCanceled.length;
    counts.canceled             = canceled.length;
    counts.odm                  = odmItems.length;

    groups.submitted            = constructNestedDataset(groupByBundle(groupByHL(submitted)));
    groups.accepted             = constructNestedDataset(groupByBundle(groupByHL(accepted)));
    groups.production           = constructNestedDataset(groupByBundle(groupByHL(production)));
    groups.shipmentScheduled    = constructNestedDataset(groupByBundle(groupByHL(shipmentScheduled)));
    groups.consolidation        = constructNestedDataset(groupByBundle(groupByHL(consolidation)));
    groups.shippedToCustomer    = constructNestedDataset(groupByBundle(groupByHL(shippedToCustomer)));
    groups.delivered            = constructNestedDataset(groupByBundle(groupByHL(delivered)));
    groups.shipmentCanceled     = constructNestedDataset(groupByBundle(groupByHL(shipmentCanceled)));
    groups.canceled             = constructNestedDataset(groupByBundle(groupByHL(canceled)));
    groups.odm                  = constructNestedDataset(groupByBundle(groupByHL(odmItems)));
    groups.allStati             = constructNestedDataset(groupByBundle(groupByHL(allStati)));

    groupCounts.submitted            = groups.submitted.length;
    groupCounts.accepted             = groups.accepted.length;
    groupCounts.production           = groups.production.length;
    groupCounts.shipmentScheduled    = groups.shipmentScheduled.length;
    groupCounts.consolidation        = groups.consolidation.length;
    groupCounts.shippedToCustomer    = groups.shippedToCustomer.length;
    groupCounts.delivered            = groups.delivered.length;
    groupCounts.shipmentCanceled     = groups.shipmentCanceled.length;
    groupCounts.canceled             = groups.canceled.length;
    groupCounts.odm                  = groups.odm.length;
}

export function PrepareActiveItemGroupsForORDCHG(items, groups, counts, groupCounts) {

    PrepareActiveItemGroups(items, groups, counts, groupCounts);

    var submitted               = SplitByStatus(items, ["Submitted", "Pending"]);
    var completed               = SplitByStatus(items, ["Completed"]);
    var allStati                = submitted.concat(completed);

    counts.submitted            = submitted.length;
    counts.completed            = completed.length;

    groups.submitted            = constructNestedDataset(groupByBundle(groupByHL(submitted)));
    groups.completed            = constructNestedDataset(groupByBundle(groupByHL(completed)));
    groups.allStati             = constructNestedDataset(groupByBundle(groupByHL(allStati)));

    groupCounts.submitted       = groups.submitted.length;
    groupCounts.completed       = groups.completed.length;
    groupCounts.allStati        = groups.allStati.length;
}

export function PrepareActiveItemGroups_CSAdvExch(items, groups, counts, groupCounts) {

    var processing              = SplitByStatus(items, ["Acked", "Processing", "Pending", "ShipmentScheduled"]);
    var shippedToCustomer       = SplitByStatus(items, ["Shipped"]);
    var delivered               = SplitByStatus(items, ["Delivered"]);
    var awaitingReturn          = SplitByStatus(items, ["AwaitingReturn", "Collected"]);
    var received                = SplitByStatus(items, ["Received"]);
    var repairInProgress        = SplitByStatus(items, ["RepairInProgress"]);
    var repairComplete          = SplitByStatus(items, ["RepairComplete"]);
    var shipmentCanceled        = SplitByStatus(items, ["ShipmentCanceled"]);
    var canceled                = SplitByStatus(items, ["CANCELED"]);
    var allStati                = processing.concat(shippedToCustomer, delivered, awaitingReturn, received, repairInProgress, repairComplete, shipmentCanceled, canceled);
    var skip_hl_sched_logic     = true;

    counts.processing           = processing.length;
    counts.shippedToCustomer    = shippedToCustomer.length;
    counts.delivered            = delivered.length;
    counts.awaitingReturn       = awaitingReturn.length;
    counts.received             = received.length;
    counts.repairInProgress     = repairInProgress.length;
    counts.repairComplete       = repairComplete.length;
    counts.shipmentCanceled     = shipmentCanceled.length;
    counts.canceled             = canceled.length;


    groups.processing           = constructNestedDataset(groupByBundle(groupByHL(processing,        skip_hl_sched_logic)));
    groups.shippedToCustomer    = constructNestedDataset(groupByBundle(groupByHL(shippedToCustomer, skip_hl_sched_logic)));
    groups.delivered            = constructNestedDataset(groupByBundle(groupByHL(delivered,         skip_hl_sched_logic)));
    groups.awaitingReturn       = constructNestedDataset(groupByBundle(groupByHL(awaitingReturn,    skip_hl_sched_logic)));
    groups.received             = constructNestedDataset(groupByBundle(groupByHL(received,          skip_hl_sched_logic)));
    groups.repairInProgress     = constructNestedDataset(groupByBundle(groupByHL(repairInProgress,  skip_hl_sched_logic)));
    groups.repairComplete       = constructNestedDataset(groupByBundle(groupByHL(repairComplete,    skip_hl_sched_logic)));
    groups.canceled             = constructNestedDataset(groupByBundle(groupByHL(canceled,          skip_hl_sched_logic)));
    groups.shipmentCanceled     = constructNestedDataset(groupByBundle(groupByHL(shipmentCanceled,  skip_hl_sched_logic)));
    groups.allStati             = constructNestedDataset(groupByBundle(groupByHL(allStati,          skip_hl_sched_logic)));

    groupCounts.processing           = groups.processing.length;
    groupCounts.shippedToCustomer    = groups.shippedToCustomer.length;
    groupCounts.delivered            = groups.delivered.length;
    groupCounts.awaitingReturn       = groups.awaitingReturn.length;
    groupCounts.received             = groups.received.length;
    groupCounts.repairInProgress     = groups.repairInProgress.length;
    groupCounts.repairComplete       = groups.repairComplete.length;
    groupCounts.shipmentCanceled     = groups.shipmentCanceled.length;
    groupCounts.canceled             = groups.canceled.length;
}

export function PrepareItemGroups(items, groups, counts) {
    var openItems = SplitByStatus(items, ["Submitted", "Acked", "Processing", "AwaitingReturn", "Pending", "ShipmentScheduled", "Production", "ProductionDone", "FactShipped", "Registered", "Collected", "RepairInProgress", "RepairComplete"]);
    var shippedItems = SplitByStatus(items, ["Shipped", "Delivered", "Received"]);
    var canceledItems = SplitByStatus(items, ["ShipmentCanceled", "CANCELED"]);
    var odmItems = SplitByOdm(items, ["Submitted", "Acked", "Processing", "Production", "ProductionDone"]);
    var eOdmItems = openItems.concat(shippedItems, canceledItems);

    counts.open     = openItems.length;
    counts.shipped  = shippedItems.length;
    counts.canceled = canceledItems.length;
    counts.odm      = odmItems.length;
    counts.eOdmItems = eOdmItems.length;

    groups.open = constructNestedDataset(groupByBundle(groupByHL(openItems)));
    groups.shipped = constructNestedDataset(groupByBundle(groupByHL(shippedItems)));
    groups.canceled = constructNestedDataset(groupByBundle(groupByHL(canceledItems)));
    groups.odm = constructNestedDataset(groupByBundle(groupByHL(odmItems)));
    groups.eOdmItems = constructNestedDataset(groupByBundle(groupByHL(eOdmItems)));
}

export function formDataStructure(data) {
    var firstLevel = [];
    var treeStructure = {};

    data.map(function(row) {
        if (row.folder != null) {

            if (row.folder.match(/^\//)) {
                row.folder = row.folder.substr(1, row.folder.length - 1);
            }

            //folderPath=row.folder+"/"+row.alert_profile_name;
            firstLevel = row.folder.split(/\//g);
            // we have to make dynamic levels depending
            //console.log(firstLevel[0]);

            var profileData = {
                "type": row.source,
                "profile_id": row.alert_profile_id,
                "profile_name": row.alert_profile_name,
                "profile_rule": row.alert_profile_expression,
                "profile_rule_descr": row.alert_profile_expression_descr,
                "folder": row.folder,
                "created_by": row.created_by,
                "created_on": row.created_on,
                "last_changed_by": row.last_changed_by,
                "last_changed_on": row.last_changed_on
            };

            if (treeStructure[firstLevel[0]] == undefined) {
                treeStructure[firstLevel[0]] = {};
            }

            if (firstLevel.length == 1) {
                treeStructure[firstLevel[0]][row.alert_profile_name] = profileData;
            } else if (firstLevel.length == 2) {

                if (treeStructure[firstLevel[0]][firstLevel[1]] == undefined) {
                    treeStructure[firstLevel[0]][firstLevel[1]] = {};
                }

                treeStructure[firstLevel[0]][firstLevel[1]][row.alert_profile_name] = profileData;


            } else if (firstLevel.length == 3) {

                if (treeStructure[firstLevel[0]][firstLevel[1]] == undefined) {
                    treeStructure[firstLevel[0]][firstLevel[1]] = {};
                }
                if (treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]] == undefined) {
                    treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]] = {};

                }
                treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]][row.alert_profile_name] = profileData;

            } else if (firstLevel.length == 4) {

                if (treeStructure[firstLevel[0]][firstLevel[1]] == undefined) {
                    treeStructure[firstLevel[0]][firstLevel[1]] = {};
                }

                if (treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]] == undefined) {
                    treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]] = {};
                }

                if (treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]][firstLevel[3]] == undefined) {
                    treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]][firstLevel[3]] = {};

                }
                treeStructure[firstLevel[0]][firstLevel[1]][firstLevel[2]][firstLevel[3]][row.alert_profile_name] = profileData;
            }

        }
    });
    return treeStructure;
}

function skipException(exception) {

    // Hide shipment and credit hold codes at item level & OpCode at header level
    if (exception.type == "ship" || exception.type == "credit" || exception.type == "opcode")
        return 1;

    if (exception.cat != undefined && exception.cat != "") {

        // Hide hold/block codes having 'hide' category
        if (exception.cat == "hide") return 1;

        // Hide hold/block codes having 'info' category, except at header level
        if (exception.cat == "info") {
            if (exception.type != "header" && exception.type != "othersys")
                return 1;
        }
    }

    return 0;
}

function formatException( tenant, exception, handleBlockRelease, lno, item_no, exceptionArea, actionableCodes) {

    var fmCode = null;
    var fmText = null;
    var catText = "";

    if (exception.etext && exception.etext != null && exception.etext != "") {
      exception.text = T(exception.etext);
    }
    
    if (skipException(exception)) return "";

    if (exceptionArea != "ex") {
      if (exception.cat == "info") {

        fmCode =  React.createElement('span', {},
                  React.createElement('i', {  className: "glyphicon glyphicon-upload", 
                                              style: {"fontSize": "15px", "color": "#cccccc"},
                                           }
                                     ),
                  React.createElement('span', {style: {"display":"inline-block", "padding":"0 5px","minWidth":"50px"}}, " " + exception.code+" : ")
        );

      } else {
      
        console.log(handleBlockRelease);
    
        if (actionableCodes.indexOf(exception.code) == -1 || handleBlockRelease == null) {
          fmCode = React.createElement('span', {},
                      React.createElement('i', { className: "glyphicon glyphicon-upload", 
                                                 style:   {"fontSize": "15px", "color": "#cccccc"}, 
                                               }
                                         ),
                      React.createElement('span', {style: {"color":"#e00","display":"inline-block", "padding":"0 5px","minWidth":"50px"}}, " " + exception.code+" : ")
                   );
        } else {
          fmCode = React.createElement('span', {},
                      React.createElement('i', {  className: "glyphicon glyphicon-upload", 
                                                  style:   {"fontSize": "15px", "color": "#cc0000"}, 
                                                  title:   "release block code: "+exception.code,
                                                  onClick: handleBlockRelease ? handleBlockRelease.bind(null, lno, item_no, exceptionArea, exception) : null
                                                }
                                        ),
                      React.createElement('span', {style: {"color":"#e00","display":"inline-block", "padding":"0 5px","minWidth":"50px"}}, " " + exception.code+" : ")
                   );
        }        
      }
    }        
    if (exception.text != undefined && exception.text != "") {
        fmText = React.createElement('span', {}, exception.text);
    }
    if ( (tenant != "HPI") && exception.cat_name != undefined && exception.cat_name != "") {

        catText += " (" + exception.cat_name;

        if (exception.subcat_name != undefined && exception.subcat_name != "") {
            catText += " / " + exception.subcat_name;
        }
        catText += ")";
    }

    return React.createElement('div', {}, [ fmCode, fmText, React.createElement('span', {key: item_no}, catText) ]);
}


export function countHeaderBlocks(exceptions) 
{
  var nrBlocks = 0;
  
  for (var exception in exceptions) {
    if (exception != "header" && exception != "billing" && exception != "delivery" && exception != "othersys") {
      continue
    }
    for (var code in exceptions[exception]) {
      if (code == "hasExtExceptionComment") {
        continue
      }
      if (Object.keys(exceptions[exception][code]).length > 0) {      
        for (var system in exceptions[exception][code]) {        
          //console.log(exception + '_' + code +'_'+ system, exceptions[exception][code][system]);
          if (   exceptions[exception][code][system].cat != "info"
              && exceptions[exception][code][system].cat != "hide"
          ) {
            nrBlocks++;
          }
        }  
      }
    }
  }
  //console.log('nrBlocks= ' + nrBlocks); 
  return nrBlocks;
}

export function checkFieldValueExist(items,fields) {

    var retObject = {}
    for (var i = 0; i < items.length; i++) {
        fields.forEach( function(field) {
            !retObject[field] && items[i][field] ? retObject[field] = true : "" ;
            retObject[field] == 'undefined' ? retObject[field] = false :"";
        })
    }
    return retObject;
}

export function additionalInfo(tenant, userInterface, type, exceptions, exceptionArea, delvComm, ackDateComm, manAckComm, handleBlockRelease, lno, item_no, system, item_status, odm_reason, odm_priority, odm_drop ) {


    var additionalInfo = [];

    ackDateComm = ackDateComm || ""

    manAckComm = manAckComm || ""

    if ( item_status == "Admin/Acked" || item_status == "Production" || item_status == "ProductionDone" || item_status == "Shipped from Factory" || item_status == "Registered" ) {
      manAckComm = "";
    }

    if ( 0 &&  (userInterface == "in" && type == "item" && item_status != "shipped")
        //(item_status == "Admin/Acked" || item_status == "Processing" || item_status == "Production" || item_status == "ProductionDone" || item_status == "Shipped from Factory" || item_status == "Registered") 
    ) {
        //        (item.odm_reason != "" || item.odm_priority || item.odm_drop)
        if (odm_reason) {
            additionalInfo.push("ODM Comment: " + odm_reason);
        }
        if (odm_priority) {
            additionalInfo.push("ODM Reason: " + odm_priority);
        }
        if (odm_drop) {
            additionalInfo.push("ODM Drop: " + odm_drop);
        }
      }

    var actionable = [];
    
    //console.log('system:', system);
    
    
    if (type == "hdr" && exceptionArea == "header" && userInterface != "ex") {
         // header user stati
        actionable = [ '1SHP','1SOH','COP','COX','EOP',
                       'MOV','OTH','POC','WEB','ZABK' 
        ];
        if (UserSettings.config.RemovableBlockSetup && 
            UserSettings.config.RemovableBlockSetup[tenant] &&
            UserSettings.config.RemovableBlockSetup[tenant].userstatus &&
            UserSettings.config.RemovableBlockSetup[tenant].userstatus[system] &&
            UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].hdr
        ) { 
            console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].hdr);
            actionable = UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].hdr;
        }
    }
    if (type == "hdr" && exceptionArea == "billing") {
        // billing blocks
        actionable = [ 'J1','J2','J4','SI','IS','LB'
        ];
        if (UserSettings.config.RemovableBlockSetup && 
            UserSettings.config.RemovableBlockSetup[tenant] &&
            UserSettings.config.RemovableBlockSetup[tenant].billing &&
            UserSettings.config.RemovableBlockSetup[tenant].billing[system] &&
            UserSettings.config.RemovableBlockSetup[tenant].billing[system].hdr
        ) { 
            console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].billing[system].hdr);
            actionable = UserSettings.config.RemovableBlockSetup[tenant].billing[system].hdr;
        }
    }
    if (type == "hdr" && exceptionArea == "delivery") {
        actionable = [ '03','05'
        ];
        if (UserSettings.config.RemovableBlockSetup && 
            UserSettings.config.RemovableBlockSetup[tenant] &&
            UserSettings.config.RemovableBlockSetup[tenant].delivery &&
            UserSettings.config.RemovableBlockSetup[tenant].delivery[system] &&
            UserSettings.config.RemovableBlockSetup[tenant].delivery[system].hdr
        ) { 
            console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].delivery[system].hdr);
            actionable = UserSettings.config.RemovableBlockSetup[tenant].delivery[system].hdr;
        }
    }

    if (type == "hdr" && exceptionArea == "othersys") {
       // virtual user status
        if (UserSettings.config.RemovableBlockSetup &&
            UserSettings.config.RemovableBlockSetup[tenant] &&
            UserSettings.config.RemovableBlockSetup[tenant].userstatus &&
            UserSettings.config.RemovableBlockSetup[tenant].userstatus[system] &&
            UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].hdr
        ) {
            console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].hdr);
            actionable = UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].hdr;
        }
    }
    
    //console.log("additionalInfo called", type, exceptionArea, actionable);

    if (userInterface == "ex") {

        if ( exceptions != "" || delvComm != "" ) {

            if (!additionalInfo) additionalInfo = [];

            if(delvComm != "" || delvComm == undefined) {
                additionalInfo.push(T(delvComm));
            }

            // below line is duplicate of above line
            //if (delvComm != "") additionalInfo.push(T(delvComm));

            if (exceptions == "" ) {
                return additionalInfo;
            }

            if (type == "hdr" && exceptionArea == "header") {
              for (var exception in exceptions) {
                if (exceptionArea != null && exception != exceptionArea) {
                    continue
                }
                for (var code in exceptions[exception]) {
                  if (code == "hasExtExceptionComment") {
                    continue
                  }
                  var match = 1;
                  if ( lno.order_overall_status == "Delivered" || lno.order_overall_status == "Shipped" ) {

                    if (lno.visibleStatiCodes && 
                        lno.visibleStatiCodes[tenant] &&
                        lno.visibleStatiCodes[tenant][system])
                    {
                      match = 0;
                      for (var code_type in lno.visibleStatiCodes[tenant][system]) {
                        if (code_type == exception) {
                          for ( var match_code in lno.visibleStatiCodes[tenant][system][code_type]) {
                            if (code == lno.visibleStatiCodes[tenant][system][code_type][match_code]) {
                              match = 1;
                            }
                          }
                        }
                      }
                    } else {
                      match = 0;
                    }
                  }

                  if (match) {
                    if (Object.keys(exceptions[exception][code]).length == "0") {
                      var currExcp = {};
                      currExcp.type = exception;
                      currExcp.code = code;

                      if (currExcp.etext != undefined && currExcp.etext != "" ) {
                        var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, userInterface, actionable);
                        if (fmExcp != "") additionalInfo.push(fmExcp);
                      }

                    } else {
                      for (var system in exceptions[exception][code]) {
                        var currExcp = exceptions[exception][code][system];
                        currExcp.type = exception;
                        currExcp.code = code;
                        
                        if (currExcp.etext != undefined && currExcp.etext != "" ) {
                          var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, userInterface, actionable );
                          //console.log(fmExcp);
                          if (fmExcp != "") additionalInfo.push(fmExcp);
                        }
                      }
                    }
                  }
                }
              }
            }
            //console.log(exceptions);
            //console.log(item_status);
            if (type == "item" ) {
                for (var exception in exceptions) {
                    //console.log(exception);
                    for (var code in exceptions[exception]) {
                        if (code == "hasExtExceptionComment") {
                          continue
                        }
                        //GEGA ... only show code comments when item its forced by colum
                        var match = 1;
                        if ( item_status == "Delivered" || item_status == "Shipped to Customer" ) {
                          if (lno.visibleStatiCodes && 
                              lno.visibleStatiCodes[tenant] &&
                              lno.visibleStatiCodes[tenant][system]
                          ) {
                            match = 0;
                            for (var code_type in lno.visibleStatiCodes[tenant][system]) {
                              if (code_type == exception) {
                                for ( var match_code in lno.visibleStatiCodes[tenant][system][code_type]) {
                                  if (code == lno.visibleStatiCodes[tenant][system][code_type][match_code]) {
                                    match = 1;
                                  }
                                }
                              }
                            }
                          } else {
                            match = 0;
                          }
                        }
                        if (match) {
                          if (Object.keys(exceptions[exception][code]).length == "0") {
                              var currExcp = {};
                              currExcp.type = exception;
                              currExcp.code = code;

                              var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, userInterface, actionable );
                              if (fmExcp != "") {
                                additionalInfo.push(currExcp.etext);
                                additionalInfo = _.uniq(additionalInfo);
                              }

                          } else {
                              var currExcp = exceptions[exception][code];
                              currExcp.type = exception;
                              currExcp.code = code;

                              var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, userInterface, actionable );
                              if (fmExcp != "") {
                                additionalInfo.push(currExcp.etext);
                                additionalInfo = _.uniq(additionalInfo);
                              }
                          }
                        } 
                    }
                }
            }

        if (manAckComm != "") {
            additionalInfo.push(manAckComm);
        }


        return additionalInfo;

        } else {
            return "";
        }

    } else if (userInterface == "in") {

        if (delvComm != "") additionalInfo.push(T(delvComm));

        if (exceptions == "") {
            return additionalInfo;
        }

        if (type == "hdr") {
            for (var exception in exceptions) {
                if (exceptionArea != null && exception != exceptionArea) {
                    continue
                }
                for (var code in exceptions[exception]) {
                    if (code == "hasExtExceptionComment") {
                      continue
                    }
                    if (Object.keys(exceptions[exception][code]).length == "0") {
                        var currExcp = {};
                        currExcp.type = exception;
                        currExcp.code = code;

                        var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, exceptionArea, actionable);
                        if (fmExcp != "") additionalInfo.push(fmExcp);

                    } else {
                        for (var system in exceptions[exception][code]) {

                            var currExcp = exceptions[exception][code][system];
                            currExcp.type = exception;
                            currExcp.code = code;
                            

                            var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, exceptionArea, actionable );
                            //console.log(fmExcp);
                            if (fmExcp != "") additionalInfo.push(fmExcp);
                        }
                    }
                }
            }

        } else if (type == "item") {
            for (var exception in exceptions) {

                if (type == "item" && exception == "item") {
                    // item user stati
                    actionable = [ '1SHP','COPI','DECA','OTHI',  'POCI','SHC'
                    ];
                    if (UserSettings.config.RemovableBlockSetup && 
                        UserSettings.config.RemovableBlockSetup[tenant] &&
                        UserSettings.config.RemovableBlockSetup[tenant].userstatus &&
                        UserSettings.config.RemovableBlockSetup[tenant].userstatus[system] &&
                        UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].item
                    ) { 
                        console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].item);
                        actionable = UserSettings.config.RemovableBlockSetup[tenant].userstatus[system].item;
                    }
                }
                if (type == "item"  && exception == "billing") {
                    // billing blocks
                    actionable = [ 'J1','J2','J4','SI','IS','LB'
                    ];
                    if (UserSettings.config.RemovableBlockSetup && 
                        UserSettings.config.RemovableBlockSetup[tenant] &&
                        UserSettings.config.RemovableBlockSetup[tenant].billing &&
                        UserSettings.config.RemovableBlockSetup[tenant].billing[system] &&
                        UserSettings.config.RemovableBlockSetup[tenant].billing[system].item
                    ) { 
                        console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].billing[system].item);
                        actionable = UserSettings.config.RemovableBlockSetup[tenant].billing[system].item;
                    }
                }
                if (type == "item" && exception == "delivery") {
                    actionable = [ '03','05'
                    ];
                    if (UserSettings.config.RemovableBlockSetup && 
                        UserSettings.config.RemovableBlockSetup[tenant] &&
                        UserSettings.config.RemovableBlockSetup[tenant].delivery &&
                        UserSettings.config.RemovableBlockSetup[tenant].delivery[system] &&
                        UserSettings.config.RemovableBlockSetup[tenant].delivery[system].item
                    ) { 
                        console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].delivery[system].item);
                        actionable = UserSettings.config.RemovableBlockSetup[tenant].delivery[system].item;
                    }
                }
                if (type == "item" && exception == "rejection") {
                    actionable = [];
                    if (UserSettings.config.RemovableBlockSetup && 
                        UserSettings.config.RemovableBlockSetup[tenant] &&
                        UserSettings.config.RemovableBlockSetup[tenant].rejection &&
                        UserSettings.config.RemovableBlockSetup[tenant].rejection[system] &&
                        UserSettings.config.RemovableBlockSetup[tenant].rejection[system].item
                    ) { 
                        console.log('actionable:', UserSettings.config.RemovableBlockSetup[tenant].rejection[system].item);
                        actionable = UserSettings.config.RemovableBlockSetup[tenant].rejection[system].item;
                    }
                }
                
                for (var code in exceptions[exception]) {
                    if (code == "hasExtExceptionComment") {
                      continue
                    }
                    var match = 1;
                    if ( item_status == "Delivered" || item_status == "Shipped" ) {
                      //GEGA ... only show code comments when item its forced by colum
                      if (UserSettings.config.VisibleStatiCodes && 
                          UserSettings.config.VisibleStatiCodes[tenant] &&
                          UserSettings.config.VisibleStatiCodes[tenant][system]
                      ) {
                        match = 0;
                        for (var code_type in UserSettings.config.VisibleStatiCodes[tenant][system]) {
                          if (code_type == exception) {
                            for ( var match_code in UserSettings.config.VisibleStatiCodes[tenant][system][code_type]) {
                              if (code == UserSettings.config.VisibleStatiCodes[tenant][system][code_type][match_code]) {
                                match = 1;
                              }
                            }
                          }
                        }
                      } else {
                        match = 0;
                      }
                    }

                    if (match) {
                      if (Object.keys(exceptions[exception][code]).length == "0") {
                          var currExcp = {};
                          currExcp.type = exception;
                          currExcp.code = code;

                          var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, exceptionArea, actionable );
                          if (fmExcp != "") additionalInfo.push(fmExcp);

                      } else {
                          var currExcp = exceptions[exception][code];
                          currExcp.type = exception;
                          currExcp.code = code;

                          var fmExcp = formatException(tenant, currExcp, handleBlockRelease, lno, item_no, exceptionArea, actionable );
                          if (fmExcp != "") additionalInfo.push(fmExcp);

                      }
                    }
                }
            }
            if (ackDateComm != "") {
                additionalInfo.push("SC commit comment:");
                additionalInfo.push(ackDateComm);
            }

            if (manAckComm != "") {
                additionalInfo.push(manAckComm);
            }

        }

        // Sending back unique exceptions
        return $.grep(additionalInfo, function(el, index) {
            return index == $.inArray(el, additionalInfo);
        });
    }
}


/*----------------------------------------------------------------------------
|   setJSONforGETRequestValue
|
|   @in/out   O                 An Object where to apply the 'key' to
|   @in       key               the request param to insert/set all arguments after the second
|   @in       argument(2..N)    all arguments must be passed as two values Array,
|                               they will be applied as key/value pairs as in an object
|
\--------------------------------------------------------------------------*/
export function setJSONforGETRequestValue (O, key) {

  // console.log("setKeyForObject (" + key + ")");
  var tmpO = {}
  for (var i = 2; i < arguments.length; i++) {
    tmpO[arguments[i][0]] = arguments[i][1]
  }

  O[key] = encodeURIComponent(JSON.stringify(tmpO));
}

export function sumUpNewPriceFields (arr1, arr2, reducer_flag) {

  // Added extra condition to avoid the sum up prices recursively
  if (!arr1.is_summed_up) {
    if (reducer_flag) {
    
      ['list_price',    'price_sales_discount',    'price_contract_discount',    'price_other',    'price_shipping_charges',    'price_tax_value',    'price_fees',    'net_price',
       'list_price_dlr','price_sales_discount_dlr','price_contract_discount_dlr','price_other_dlr','price_shipping_charges_dlr','price_tax_value_dlr','price_fees_dlr','dlr_net_price'
      ].forEach( function(field) {
         var sum = 0;
         for (var i=0; i < arr2.length; i++) { sum += arr2[i][field] }
         arr1[field] += sum      
      });

    } else {
  
      arr1.list_price = arr1.list_price  + arr2.list_price
      arr1.price_sales_discount = arr1.price_sales_discount  + arr2.price_sales_discount
      arr1.price_contract_discount = arr1.price_contract_discount  + arr2.price_contract_discount
      arr1.price_other = arr1.price_other  + arr2.price_other
      arr1.price_shipping_charges = arr1.price_shipping_charges  + arr2.price_shipping_charges
      arr1.price_tax_value = arr1.price_tax_value  + arr2.price_tax_value
      arr1.price_fees = arr1.price_fees  + arr2.price_fees
      arr1.net_price = arr1.net_price  + arr2.net_price
  
      arr1.list_price_dlr = arr1.list_price_dlr + arr2.list_price_dlr 
      arr1.price_sales_discount_dlr = arr1.price_sales_discount_dlr + arr2.price_sales_discount_dlr 
      arr1.price_contract_discount_dlr = arr1.price_contract_discount_dlr + arr2.price_contract_discount_dlr 
      arr1.price_other_dlr = arr1.price_other_dlr + arr2.price_other_dlr 
      arr1.price_shipping_charges_dlr = arr1.price_shipping_charges_dlr + arr2.price_shipping_charges_dlr 
      arr1.price_tax_value_dlr = arr1.price_tax_value_dlr + arr2.price_tax_value_dlr 
      arr1.price_fees_dlr = arr1.price_fees_dlr + arr2.price_fees_dlr 
      arr1.dlr_net_price = arr1.dlr_net_price + arr2.dlr_net_price 
  
    }
    arr1.is_summed_up = true
  }
  
    return arr1
  
  }

export function getMappingFromStatus(status)
{
  let map = "FFFFFFHH";  // F=future, S=seen, C=active/current, H=hide T=Tooltip

  // (C)urrent (H)ide (S)een (F)uture
  //                                        +----------------Submitted
  //                                        |+---------------Accepted
  //                                        ||+--------------Production / ShipmentScheduled
  //                                        |||+-------------Consolidated
  //                                        ||||+------------Shipped to Customer
  //                                        |||||+-----------Delivered
  //                                        ||||||+----------ShipmentCanceled
  //                                        |||||||+---------Canceled
  if (status === "Canceled"      ) { map = "SHHHHHHC"; } else
  if (status === "CANCELED"      ) { map = "SHHHHHHC"; } else
  if (status === "Delivered"     ) { map = "SSSSSCHH"; } else
  if (status === "Shipped"       ) { map = "SSSSCFHH"; } else
  if (status === "Pending"       ) { map = "SSSSCFHH"; } else
  if (status === "Consolidation" ) { map = "SSSCFFHH"; } else
  if (status === "Registered"    ) { map = "SSSCFFHH"; } else
  if (status === "FactShipped"   ) { map = "SSSCFFHH"; } else
  if (status === "ProductionDone") { map = "SSCFFFHH"; } else
  if (status === "Production"    ) { map = "SSCFFFHH"; } else
  if (status === "Acked"         ) { map = "SCFFFFHH"; } else
  if (status === "Processing"    ) { map = "SCFFFFHH"; } else
  if (status === "Submitted"     ) { map = "CFFFFFHH"; } else
  if (status === "ShipmentScheduled"    ) { map = "SSCFFFHH"; } else
  if (status === "ShipmentCanceled"     ) { map = "SSSSSHCH"; }

  return map;
}

export function getMappingFromStatus_CS_AdvExchange(status)
{
  let map = "FFFFHH";  // F=future, S=seen, C=active/current, H=hide T=Tooltip

  // (C)urrent (H)ide (S)een (F)uture
  //                                           +----------------Processing
  //                                           |+---------------Shipped
  //                                           ||+--------------Awaiting Return
  //                                           |||+-------------Received
  //                                           ||||||+----------ShipmentCanceled
  //                                           |||||||+---------Canceled
  if (status === "Canceled"         ) { map = "SHHHHC"; } else
  if (status === "CANCELED"         ) { map = "SHHHHC"; } else
  if (status === "Received"         ) { map = "SSSCHH"; } else
  if (status === "AwaitingReturn"   ) { map = "SSCFHH"; } else
  if (status === "RepairInProgress" ) { map = "SSCFHH"; } else
  if (status === "RepairComplete"   ) { map = "SSCFHH"; } else
  if (status === "Shipped"          ) { map = "SCFFHH"; } else
  if (status === "Delivered"        ) { map = "SCFFHH"; } else
  if (status === "Processing"       ) { map = "CFFFHH"; } else
  if (status === "ShipmentCanceled" ) { map = "SSHHCH"; }

  return map;
}

export function getMappingFromStatus_SOM(status)
{
  // (C)urrent (H)ide (S)een (F)uture
  //                                        +----------------Submitted
  //                                        |+---------------Pending
  //                                        ||+--------------Active
  //                                        |||+-------------Planned
  //                                        ||||+------------Canceled  (contextual: hidden unless canceled)
  //                                        |||||+-----------Expired
  let map = "CFFFHF";  // default: at Submitted

  if (status === "Submitted") { map = "CFFFHF"; } else
  if (status === "Pending"  ) { map = "SCFFHF"; } else
  if (status === "Active"   ) { map = "SSCFHF"; } else
  if (status === "Planned"  ) { map = "SSSCHF"; } else
  if (status === "Expired"  ) { map = "SSSSHC"; } else
  if (status === "Canceled" ) { map = "SHHHCH"; } else
  if (status === "CANCELED" ) { map = "SHHHCH"; }

  return map;
}

export function getMappingFromStatus_ORDCHG(status)
{
  // (C)urrent (S)een (F)uture
  // Order Change orders have a two-state header flow: Submitted -> Completed.
  //                                        +----------------Submitted
  //                                        |+---------------Completed
  let map = "CF";  // default: at Submitted

  if (status === "Submitted") { map = "CF"; } else
  if (status === "Completed") { map = "SC"; }

  return map;
}

export async function getDataFieldObjects(userSettingsArea, defaultCols, object) {

  var dataServiceFields = {};
  var predefinedColumns = [];                  
  //var selectedColumns = [];
  var availableColumns = [];

  for (const [key, value] of Object.entries(object)) {
    //console.log(`${key}: ${value}`);

    if (typeof value === 'string') {

      const k = key.toLowerCase();
      const isDateField =
        k.endsWith('_date') ||
        k.endsWith('date') ||
        k.endsWith('_dt') ||
        k.endsWith('_lupd') ||
        k.startsWith('date_');
      const isDateTimeField =
        k.endsWith('datetime') ||
        k.endsWith('date_time') ||
        k.startsWith('datetime') ||
        k.startsWith('date_time_') ||
        k.startsWith('time_');

      let availColVal = value;
      if (isDateField) {
        availColVal = fmDate(value);
      } else if (isDateTimeField) {
        availColVal = fmDateTime(value);
      }

      availableColumns.push({
        internalName: key,
        value: availColVal
      });
    }
  
  }

  //Remove Fields from available columns that are default
  for(var i =0; i< defaultCols.length; i++ ) {
    for(var j= 0; j< availableColumns.length;j++) {
      if (defaultCols[i] === availableColumns[j].internalName) {
        predefinedColumns.push(availableColumns[j]);
        availableColumns.splice(j,1);
        break;
      }
    }
  } 

  var userSelectedCols = [];
  userSelectedCols = await UserSettings.get(userSettingsArea);
  //We need to map the selected columns with the current order values
  for(var i =0; i< userSelectedCols.length; i++ ) {
    for(var x =0; x< availableColumns.length; x++ ) {
      if (userSelectedCols[i].internalName === availableColumns[x].internalName) {
        userSelectedCols[i].value = availableColumns[x].value;
        //availableColumns.splice(x,1);
      }
    }
  }

  if (userSelectedCols.length == 0 || Object.keys(userSelectedCols).length == 0) {
    userSelectedCols = [];
  }

  dataServiceFields.predefinedColumns = predefinedColumns;
  dataServiceFields.userSelectedCols   = userSelectedCols;
  dataServiceFields.availableColumns  = availableColumns;

  return dataServiceFields;

}

export function formatIntoLabelGrid(selectedColumns, translationPrefix) {
  var lblRowArray = [];
  var lblColArray = [];
  var colCounter = 0;
  var columns = 5;
  for (var i = 0; i < selectedColumns.length; i++) {

    if (selectedColumns[i].valueOld !== undefined && selectedColumns[i].valueOld !== null) {  
      lblRowArray.push(DD(selectedColumns[i].internalName), selectedColumns[i].value, selectedColumns[i].valueOld);
    } else {
      lblRowArray.push(DD(selectedColumns[i].internalName), selectedColumns[i].value);
    }

    colCounter++
    if (colCounter == columns) {
      lblColArray.push(lblRowArray);
      colCounter = 0;
      lblRowArray = [];
    }

  }
  if (colCounter !== 0) {

    var fillUpLength = columns - lblRowArray.length / 2 ;
    for (var i = 0; i < fillUpLength; i++) {
      //lblRowArray.push("","");
    }
    lblColArray.push(lblRowArray);
  }
  return lblColArray;
}

export function genItemLevelSubReqBtn (us, order, item, parent, sccpItems) {
  var sRBtn = null;
  var sRBtnStyle = {cursor: 'pointer', marginRight: '3px', color: sccpItems.includes(item.item_subitem) ? '#0096d6' : '#bbbbbb'};

  if (us && us.tenant != "HPIFEDLLC" && window.location.host.includes('oss') && order?.order_type != 'ZMSO')
    sRBtn = <a title="Flag/Unflag items for submitting request" ref={(e) => parent.sccpBtnRefs[item.item_subitem] = e} onClick={() => parent.handleSCCPItems(item.item_subitem)} style={sRBtnStyle}><span className='glyphicon glyphicon-flag'/></a>

  return sRBtn;
}

export function getFcdnStatusText(workflow_status) {
    if (!workflow_status) return "";

    var wfStatus = workflow_status.toLowerCase();

    if (wfStatus === 'new' || wfStatus === '1st_notif_sent' ||
        wfStatus === '2nd_notif_sent' || wfStatus === '3rd_notif_sent') {
        return 'Waiting customer update';
    } else if (wfStatus === 'uit_received' || wfStatus === 'uit_transmitted') {
        return 'Updated by customer';
    } else if (wfStatus === 'delivered') {
        return 'Delivered';
    }

    return workflow_status;
}

export function genItemLevelSubReqBtnExt (us, order, item, parent, crpItems) {
  var sRBtn = null;
  var sRBtnStyle = {cursor: 'pointer', marginRight: '3px', color: crpItems.includes(item.item_subitem) ? '#0096d6' : '#bbbbbb'};

  if (us && us.tenant != "HPIFEDLLC" && order?.order_type != 'ZMSO')
    sRBtn = <a title="Flag/Unflag items for submitting request" ref={(e) => parent.crpBtnRefs[item.item_subitem] = e} onClick={() => parent.handleCRPItems(item.item_subitem)} style={sRBtnStyle}><span className='glyphicon glyphicon-flag'/></a>

  return sRBtn;
}
